import { render, staticRenderFns } from "./MediumMediaSetting.vue?vue&type=template&id=10c65a96&"
import script from "./MediumMediaSetting.vue?vue&type=script&lang=js&"
export * from "./MediumMediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports